import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/about": [7],
		"/account": [8,[2]],
		"/account/history": [9,[2]],
		"/account/settings": [10,[2]],
		"/admin": [11,[3],[4]],
		"/admin/categories": [12,[3],[4]],
		"/admin/series": [13,[3,5],[4]],
		"/admin/series/add": [14,[3,5],[4]],
		"/admin/series/edit/[id]": [15,[3,5],[4]],
		"/admin/users": [16,[3],[4]],
		"/admin/users/edit/[id]": [17,[3],[4]],
		"/deletion": [18],
		"/explore": [19],
		"/explore/[section]": [20],
		"/privacy": [21],
		"/series": [22],
		"/series/[series]": [23],
		"/series/[series]/[chapter]": [24],
		"/terms": [25],
		"/test": [26]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';